<template>
  <div class="baseInfoBox">
    <el-form
      ref="baseDataForm"
      :rules="baseDataRules"
      label-width="100px"
      :model="baseData"
      :disabled="turnType === '3' || (turnType === '1' && currStatus !== 'draft')"
    >
      <el-row>
        <!-- <el-col :span="6">
          <el-form-item label="客户名称" prop="customerNo">
            <search-table
              v-model="baseData.customerNo"
              searchType="partner"
              :isMultiple="true"
              :currentValue="baseData.customerName ? baseData.customerName : ''"
              :checkRowKeys="baseData.customerNo ? [baseData.customerNo] : []"
              @input="(val) => chooseForm(val, 'customerNo')"
            ></search-table>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="6">
          <el-form-item label="客户合同" prop="contractCode">
            <el-select
              placeholder="请选择合同号"
              v-model="baseData.contractCode"
              filterable
              clearable
              @change="handleContractChange"
            >
              <el-option
                v-for="(item, index) in contractList"
                :key="index"
                :label="item.contractName"
                :value="item.contractCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="客户合同" prop="contractCode">
            <search-table
              v-model="baseData.contractName"
              searchType="multransportContract"
              :extraData="{
                isCS: 'C',
                contractStatus: 'ZT03',
                contractType: '0',
                platformCompanyName: this.userInfo.companyName,
              }"
              :isMultiple="true"
              :currentValue="baseData.contractName ? baseData.contractName : ''"
              :checkRowKeys="baseData.contractCode ? [baseData.contractCode] : []"
              :disabled="turnType === '3' || (turnType === '1' && currStatus !== 'draft')"
              @input="(val) => chooseForm(val, 'contractCode')"
            ></search-table>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户名称">
            <el-tooltip
              :disabled="!baseData.customerName"
              class="item"
              effect="dark"
              :content="baseData.customerName"
              placement="top"
            >
              <!-- <el-input
                v-model="baseData.customerCode"
                :disabled="!baseData.contractName"
              ></el-input> -->
              <el-select
                v-model="baseData.customerNo"
                style="width: 100%"
                placeholder="请选择客户名称"
                :disabled="!baseData.contractName"
                @change="customerChange"
              >
                <el-option
                  v-for="(item, index) in customerList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目名称">
            <el-tooltip
              :disabled="!baseData.projectName"
              class="item"
              effect="dark"
              :content="baseData.projectName"
              placement="top"
            >
              <el-input v-model="baseData.projectName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户联系人">
            <el-tooltip
              :disabled="!baseData.customerContactName"
              class="item"
              effect="dark"
              :content="baseData.customerContactName"
              placement="top"
            >
              <el-input v-model="baseData.customerContactName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="客户联系方式">
            <el-tooltip
              :disabled="!baseData.customerContactPhone"
              class="item"
              effect="dark"
              :content="baseData.customerContactPhone"
              placement="top"
            >
              <el-input v-model="baseData.customerContactPhone" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="平台公司">
            <el-tooltip
              :disabled="!baseData.platformCompanyName"
              class="item"
              effect="dark"
              :content="baseData.platformCompanyName"
              placement="top"
            >
              <el-input v-model="baseData.platformCompanyName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="销售组织">
            <el-tooltip
              :disabled="!baseData.saleDepartmentName"
              class="item"
              effect="dark"
              :content="baseData.saleDepartmentName"
              placement="top"
            >
              <el-input v-model="baseData.saleDepartmentName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="业务员">
            <el-tooltip
              :disabled="!baseData.salesmanName"
              class="item"
              effect="dark"
              :content="baseData.salesmanName"
              placement="top"
            >
              <el-input v-model="baseData.salesmanName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单创建人">
            <el-tooltip
              :disabled="!computedOrderCreatorName"
              class="item"
              effect="dark"
              :content="computedOrderCreatorName"
              placement="top"
            >
              <el-input v-model="computedOrderCreatorName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="6">
          <el-form-item label="订单创建人">
            <el-tooltip
              :disabled="!computedOrderCreatorName"
              class="item"
              effect="dark"
              :content="computedOrderCreatorName"
              placement="top"
            >
              <el-input v-model="computedOrderCreatorName" disabled></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="订单创建时间">
            <el-date-picker
              class="inputWidth"
              v-model="baseData.orderCreateDate"
              value-format="yyyy-MM-dd"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运输要求">
            <el-tooltip
              :disabled="!baseData.customerTransportRequire"
              class="item"
              effect="dark"
              :content="baseData.customerTransportRequire"
              placement="top"
            >
              <el-input v-model="baseData.customerTransportRequire"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单完成时间">
            <el-date-picker
              class="inputWidth"
              v-model="baseData.orderCompletedDate"
              value-format="yyyy-MM-dd"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="总件数">
            <div class="block">
              <span>
                <el-input-number
                  :min="0"
                  size="small"
                  v-model="baseData.totalQty"
                ></el-input-number>
              </span>
              <span>
                <el-select
                  v-model="baseData.totalQtyUnit"
                  style="marginleft: 6px"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="(item, index) in numberUnitList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="test-item">
          <el-form-item label="结算重量" prop="totalRoughWeight">
            <el-input-number
              :min="0"
              size="small"
              v-model="baseData.totalRoughWeight"
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="totalRoughWeightUnit" class="test">
            <el-select v-model="baseData.totalRoughWeightUnit" placeholder="请选择单位">
              <el-option
                v-for="(item, index) in weightUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="总毛重" prop="totalRoughWeight">
            <div class="block">
              <span>
                <el-input-number size="small" v-model="baseData.totalRoughWeight"></el-input-number>
              </span>
              <span>
                <el-select
                  v-model="baseData.totalRoughWeightUnit"
                  style="marginleft: 6px"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="(item, index) in weightUnitList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </div>
          </el-form-item> -->
        </el-col>
        <el-col :span="6" class="test-item">
          <el-form-item label="总净重" prop="totalNetWeight">
            <el-input-number
              size="small"
              :min="0"
              v-model="baseData.totalNetWeight"
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="totalNetWeightUnit" class="test">
            <el-select v-model="baseData.totalNetWeightUnit" placeholder="请选择单位">
              <el-option
                v-for="(item, index) in weightUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="总净重" prop="totalNetWeight">
            <div class="block">
              <span>
                <el-input-number size="small" v-model="baseData.totalNetWeight"></el-input-number>
              </span>
              <span>
                <el-select
                  v-model="baseData.totalNetWeightUnit"
                  style="marginleft: 6px"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="(item, index) in weightUnitList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </div>
          </el-form-item> -->
        </el-col>
        <el-col :span="6" class="test-item">
          <el-form-item label="总体积" prop="totalVolume">
            <el-input-number size="small" :min="0" v-model="baseData.totalVolume"></el-input-number>
          </el-form-item>
          <el-form-item prop="totalVolumeUnit" class="test">
            <el-select
              v-model="baseData.totalVolumeUnit"
              style="marginleft: 6px"
              placeholder="请选择单位"
            >
              <el-option
                v-for="(item, index) in volumeUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="总体积" prop="totalVolume">
            <div class="block">
              <span>
                <el-input-number size="small" v-model="baseData.totalVolume"></el-input-number>
              </span>
              <span>
                <el-select
                  v-model="baseData.totalVolumeUnit"
                  style="marginleft: 6px"
                  placeholder="请选择单位"
                >
                  <el-option
                    v-for="(item, index) in volumeUnitList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </div>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-col :span="6">
        <el-form-item label="是否箱型运输">
          <el-checkbox v-model="baseData.isTrucksTransport" @change="handleTrans"></el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item label="箱型/箱量" prop="number">
          <BoxType
            :boxList="boxList"
            :typeList="containerTypeList"
            :turnType="turnType"
            :boxDisabled="baseData.isTrucksTransport"
            @add="handleAdd"
            @deleteItem="deleteItem"
            @handleChange="handleChange"
            @handleSelect="handleSelect"
          />
          <el-input v-model="baseData.number" placeholder="" class="input"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
  // import searchTable from '@/components/form-item/search-table';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import bus from '@/common/js/bus';
  import BoxType from './boxType';
  import { mapState } from 'vuex';
  // import API from '@/api/intermodality/order';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import moment from 'moment';
  // import XEUtils from 'xe-utils';
  export default {
    name: 'baseDataForm',
    mixins: [orderMixin],
    props: ['turnType', 'baseDataDetailInfo', 'currStatus'],
    components: {
      // searchTable,
      BoxType,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      computedOrderCreatorName() {
        return this.baseData.orderCreatorName
          ? this.baseData.orderCreatorName
          : this.userInfo.personName;
      },
      baseDataRules() {
        return {
          customerNo: [
            {
              required: true,
              message: '请选择客户名称',
              trigger: ['blur', 'change'],
            },
          ],
          contractCode: [
            {
              required: true,
              message: '请选择客户合同',
              trigger: ['blur', 'change'],
            },
          ],
          // totalRoughWeight: [
          //   {
          //     required: true,
          //     message: '请填写总毛重',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          totalRoughWeightUnit: [
            {
              required: true,
              message: '请填写总毛重',
              trigger: ['blur', 'change'],
            },
          ],
          // totalNetWeight: [
          //   {
          //     required: true,
          //     message: '请填写总净重',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          totalNetWeightUnit: [
            {
              required: true,
              message: '请填写总净重',
              trigger: ['blur', 'change'],
            },
          ],
          // totalVolume: [
          //   {
          //     required: true,
          //     message: '请填写总体积',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          // totalVolumeUnit: [
          //   {
          //     required: true,
          //     message: '请填写总体积',
          //     trigger: ['blur', 'change'],
          //   },
          // ],
          number: [
            {
              required: this.baseData.isTrucksTransport,
              message: '请填写箱型/箱量',
              trigger: ['blur'],
            },
          ],
          // containerTypeNum: [
          //   {
          //     required: this.baseData.isTrucksTransport,
          //     message: '请填写箱型/箱量',
          //     trigger: ['change'],
          //   },
          // ],
        };
      },
    },
    watch: {
      baseDataDetailInfo(newVal) {
        if (newVal) {
          this.baseDataDetailInfo = newVal;
          this.getBaseDataDetailInfo();
          // this.getCustomerList(this.baseDataDetailInfo.contractCode);
        }
      },
    },
    data() {
      return {
        baseData: {
          customerNo: '',
          customerName: '',
          contractCode: '',
          contractName: '',
          projectName: '',
          customerContactName: '',
          customerContactPhone: '',
          platformCompanyNo: '',
          platformCompanyName: '',
          saleDepartmentName: '',
          saleDepartmentNo: '',
          createDepartmentName: '',
          createDepartmentNo: '',
          businessDepartmentCode: '',
          businessDepartmentName: '',
          salesmanName: '',
          salesmanId: '',
          orderCreateDate: '',
          orderCompletedDate: '',
          orderCreatorName: '',
          orderCreatorId: '',
          customerTransportRequire: '',
          totalQty: '', // 总件数
          totalQtyUnit: 'ByPiece', //总件数单位
          totalRoughWeight: '', // 总毛重
          totalRoughWeightUnit: 'TO', // 总毛重单位
          totalNetWeight: '', // 总净重
          totalNetWeightUnit: 'TO', // 总净重单位
          totalVolume: '', // 总体积
          totalVolumeUnit: 'M3', // 总体积单位
          isTrucksTransport: false,
          number: '',
          lopOrderCode: null,
        },
        customerList: [],
        contractList: [],
        numberUnitList: [], // 件数单位
        weightUnitList: [], // 重量单位
        volumeUnitList: [], // 体积单位
        typeList: [], // 箱型列表
        boxList: [{ type: '', number: '' }], // 箱型 默认由一个
        boxDisabled: true,
      };
    },
    created() {
      this.getUnitList();
      this.getWeightUnitList();
      this.getVolumeUnitList();
      this.getContainerTypeList();
      this.getContractList();
      if (this.turnType === '0') {
        this.baseData.orderCreateDate = moment(new Date()).format('yyyy-MM-DD hh:mm:ss');
        // this.baseData.orderCreateDate = new Date();
        this.baseData.orderCreatorName = this.userInfo.personName;
        this.baseData.orderCreatorId = this.userInfo.userCode;
      } else if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
        console.log('查看详情');
        this.getBaseDataDetailInfo();
      }
    },
    methods: {
      async getCustomerList(contractCode) {
        if (!contractCode) return;
        const { data } = await this.$axios.post(SALE_API.GET_CUSTOMER_BY_CONTRACT, {
          contractCode,
        });
        this.customerList = data.data.map((v) => {
          v.label = v.customerName;
          v.value = v.customerCode;
          return v;
        });
      },
      customerChange(val) {
        const item = this.customerList.find((v) => v.customerCode == val);
        if (item) {
          this.$set(this.baseData, 'customerName', item.customerName);
          this.$set(this.baseData, 'customerContactName', item.contactPerson);
          this.$set(this.baseData, 'customerContactPhone', item.contactPhone);
        }
      },
      async getBaseDataDetailInfo() {
        // if (this.baseDataDetailInfo.customerNo) {
        //   await this.getContractList(this.baseDataDetailInfo.customerNo);
        // }
        if (this.baseDataDetailInfo.contractCode) {
          await this.handleContractChange(this.baseDataDetailInfo.contractCode);
          this.getCustomerList(this.baseDataDetailInfo.contractCode);
        }
        this.baseData.orderCreatorName = this.userInfo.personName;
        this.baseData.orderCreatorId = this.userInfo.userCode;
        this.boxList = this.baseDataDetailInfo.containerTypeNum || this.boxList;
        Object.assign(this.baseData, this.baseDataDetailInfo);
        this.baseData.number = '1';
        if (this.turnType === '2') {
          this.baseData.orderCreateDate = moment(new Date()).format('yyyy-MM-DD hh:mm:ss');
        }
        console.log(this.baseData, 'baseData');
      },
      chooseForm(val, field) {
        if (field === 'customerNo') {
          // 客户名称
          if (val.length > 0) {
            console.log(val[0], '------');
            const partnerCode = val[0].partnerCode || 'HZHB0100002151';
            // const partnerCode = 'HZHB0100002151';
            this.partnerCode = partnerCode;
            this.companyCode = val[0].companyCode || '7000';
            this.companyName = val[0].companyName || '';
            this.contractList = [];
            this.baseData.contractCode = '';
            // 根据选中客户去查合同
            // this.getContractList(partnerCode);
          }
        }
        if (field === 'contractCode') {
          console.log(val, '1111111111');
          const code = val[0].contractCode || '';
          this.getCustomerList(code);
          this.handleContractChange(code);
        }
      },
      async getContractList() {
        console.log('11111-----');
        // if (!partnerCode) return;
        const params = {
          // customerCode: partnerCode || 'HZHB0100002151',
          isCS: 'C',
          contractStatus: 'ZT03',
          contractType: '0',
          platformCompanyName: this.userInfo.companyName,
        };
        console.log(params, '=-=-===================');
        await this.$axios.post(SALE_API.MULTRANSPORT_CONTRACT_LIST_API, params).then((res) => {
          console.log(res, '=-=-===================11111');
          if (res.data.code === 0) {
            let list = res.data.data || [];
            if (list.length > 0) {
              list.forEach((item) => {
                item.label = item.contractName;
                item.value = item.contractCode;
              });
            }
            this.contractList = list;
          }
        });
      },
      // 合同变化 需带出下列表格中的采购组织=销售组织
      async handleContractChange(val) {
        console.log(val, this.contractList, '222222-----');
        // 需带出的数据
        let obj = {};
        let filterArr = this.contractList.filter((item) => item.contractCode === val);
        obj = filterArr[0] || {};
        console.log(obj, obj.createDepartmentName, '------');

        // 赋值表格数据
        this.baseData.customerName = obj.customerName
          ? obj.customerName.split(',')[0]
          : obj.customerName;
        this.baseData.customerNo = obj.customerCode
          ? obj.customerCode.split(',')[0]
          : obj.customerCode;
        this.baseData.contractName = obj.contractName;
        this.baseData.contractCode = obj.contractCode;
        this.baseData.projectName = obj.projectName;
        this.baseData.projectCode = obj.projectCode;
        this.baseData.customerContactName = obj.contactPerson
          ? obj.contactPerson.split(',')[0]
          : obj.contactPerson;
        this.baseData.customerContactPhone = obj.contactPhone
          ? obj.contactPhone.split(',')[0]
          : obj.contactPhone;
        this.baseData.platformCompanyName = obj.platformCompanyName;
        this.baseData.platformCompanyNo = obj.platformCompanyCode;
        this.baseData.saleDepartmentName = obj.saleDepartmentName;
        this.baseData.saleDepartmentNo = obj.saleDepartmentNo;
        this.baseData.createDepartmentName = obj.createDepartmentName;
        this.baseData.createDepartmentNo = obj.createDepartmentNo;

        this.baseData.businessDepartmentName = obj.businessDepartmentName;
        this.baseData.businessDepartmentCode = obj.businessDepartmentCode;

        this.baseData.createCompanyName = obj.platformCompanyName || 'createCompanyName';
        this.baseData.createCompanyNo = obj.platformCompanyCode || 'createCompanyNo';
        this.baseData.salesmanName = obj.chargePersonName;
        this.baseData.salesmanId = obj.chargePersonId;
        // 查询合同的公司code
        this.baseData.companyCode = obj.platformCompanyCode;
        this.baseData.companyName = obj.platformCompanyName;
        this.baseData.partnerCode = this.partnerCode;
        console.log(this.baseData, 'this.baseData22');
        await this.$emit('contractChange', obj);
        // // 取出客户名称数据
        // if (this.baseData.customerNo) {
        //   const customerObj = XEUtils.clone(this.baseData.customerNo[0]);
        //   this.baseData.customerNo = customerObj.partnerCode;
        //   this.baseData.customerName = customerObj.partnerZhName;
        // }
      },
      handleTrans(val) {
        console.log(val, this.number, '23456');
        this.boxList = [{ type: '', number: '' }];
        this.baseData.number = '';
      },
      handleAdd() {
        this.boxList.push({
          type: '',
          number: '',
        });
      },
      handleChange() {
        bus.$emit('baseBoxList', this.boxList);
      },
      handleSelect() {
        console.log('12345');
        this.$nextTick(() => {
          this.baseData.number = '2';
        });
      },
      deleteItem(item, index) {
        console.log(this.boxList, '1234');
        if (this.boxList.length === 0) {
          this.$nextTick(() => {
            this.baseData.number = '';
          });
        }
        this.boxList.splice(index, 1);
        bus.$emit('baseBoxList', this.boxList);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .block {
    display: flex;
    flex-direction: row;
  }
  .test {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .test-item {
    display: flex;
  }
  .input {
    z-index: -999;
    position: absolute;
    left: -999;
    top: -999;
  }
</style>
